import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Link } from 'react-router-dom';


// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import TrainingStaffDate from './TrainingStaffDate';
import getLocale from '../../../i18n/getLocale';

class TrainingsCertificationModalEditExaminersTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      training_certification_id: this.props.training_certification_id,
      updated: this.props.updated,
      staff_list: [],
      training_certification_id: '',
      staff_id: '',
      hours: '',
    };

    this.locale = getLocale();

    //bind específico
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.ActionInputs = this.ActionInputs.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.training_certification_id !== 'undefined' && Array.isArray(newProps.staff_list) && Array.isArray(newProps.examiners_data)) || (this.state.loaded === 1 && newProps.updated === 1)){
      this.setState({
        training_certification_id: newProps.training_certification_id,
        staff_list: newProps.staff_list,
        examiners_data: newProps.examiners_data,
        loaded: 1,
      });
    }
  }
  
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.state.staff_id,
      training_certification_id: this.state.training_certification_id,
      training_certification_type_id: 3,
      hours: this.state.hours,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificado/examinador', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateDataModal(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (event) {
    var training_certification_staff_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.tabAulas.tabExaminadores.deletarExaminador);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificado/examinador/' + training_certification_staff_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateDataModal(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  ActionInputs (cell, row) {
    var data = this.props.examiners_data;
    var date_start_str = this.props.date_start_str;
    var date_finish_str = this.props.date_finish_str;
    data.map(function(dado, index){
      if(cell === dado.id) {
        date_start_str = dado.date_start_str;
        date_finish_str = dado.date_finish_str;
      }
    });
    var botao = (
      <TrainingStaffDate training_certification_staff_id={cell} status={this.props.status} date_start={date_start_str} date_finish={date_finish_str} updateData={this.props.updateDataModal} handleAlert={this.props.handleAlert} />
    );

    return botao;
  }

  ActionsButtons (cell, row) {
    var url = '/treinamento/editar/' + cell;
    
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabExaminadores.tituloAdicionarExaminador}</h3>
  <hr/>
  <form onSubmit={this.add}> 
    <div className="form-group">
      <label>{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabExaminadores.formulario.Examinador}:</label>
      <Select
        className="form-field-name"
        name="staff_id"
        value={this.state.staff_id}
        searchable={true}
        placeholder={this.locale.Treinamentos.EditarTreinamento.tabAulas.tabExaminadores.formulario.placeholder.SelecionarExaminador}
        onChange={this.handleSelectChange.bind(this, 'staff_id')}
        options={this.state.staff_list}
      />
    </div>
    <div className="form-group">
      <label>{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabExaminadores.formulario.CargaHoraria}:</label>
      <InputMask value={this.state.hours}  maskChar={null} name="hours" mask="99" className="form-control" onChange={this.handleChange.bind(this, 'hours')} placeholder={this.locale.Treinamentos.EditarTreinamento.tabAulas.tabExaminadores.formulario.placeholder.PreenchaACargaHoraria} />
    </div>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-plus"></i> {this.locale.Treinamentos.EditarTreinamento.tabAulas.tabExaminadores.formulario.botaoAdicionarExaminador}</button>
  </form>
  <hr/>
  <h3 className="page-title">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabExaminadores.tituloListaDeExaminadores}</h3>
  <hr/>
    <BootstrapTable data={this.props.examiners_data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Treinamentos.EditarTreinamento.tabAulas.tabExaminadores.tabelaListaDeExaminadores.semCertificados}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

      <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabExaminadores.tabelaListaDeExaminadores.ID}</TableHeaderColumn>

      <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabExaminadores.tabelaListaDeExaminadores.Examinador}</TableHeaderColumn>

      <TableHeaderColumn dataField="hours" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='90'>{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabExaminadores.tabelaListaDeExaminadores.Horas}</TableHeaderColumn>

      <TableHeaderColumn dataField="certification_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabExaminadores.tabelaListaDeExaminadores.Certificado}</TableHeaderColumn>

      <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionInputs} width='500'>{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabExaminadores.tabelaListaDeExaminadores.Periodo}</TableHeaderColumn>
      
      <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='120'>{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabExaminadores.tabelaListaDeExaminadores.Acoes}</TableHeaderColumn>

    </BootstrapTable>
</div>
    );
  }
}

export default TrainingsCertificationModalEditExaminersTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingsCertificationModalEditExaminersTab.js